import React, { useEffect, useState, useRef } from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";

import { LicenseInfo } from "@mui/x-license";

import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { Button, IconButton, Select, styled, Tooltip } from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";


import {
  Box,
  Grid,
  Typography,
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
} from "@mui/material";

import Divider from "@mui/material/Divider";


import axios from "../../api/axios";

import { muixlicensekey, url } from "../../configlink";
import { useSelector } from "react-redux";


const ReferralTable = () => {

  let adminUser = useSelector((state) => state.userAdmin.userAdmin)

  const [data, setData] = useState([]);
  const [dataDuplicate, setDataDuplicate] = useState([]);

  const [query, setQuery] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [currRowPerPage, setCurrRowPerPage] = useState(50);
  const [totalRowCount, setTotalRowCount] = useState(1000);



  const [search_value, setSearchValue] = useState("");

  const [statusBox, setStatusBox] = useState(-1);

  const handleStatusBoxChange = (event) => {
    setStatusBox(event.target.value)
    
    let filter

    if(event.target.value !== -1 ){
      filter = dataDuplicate.filter(x => x.isComplete === event.target.value )
      setData(filter)
    }
    else {
      setData(dataDuplicate)
    }

  }

  useEffect(() => {
    getAllReferrals();
  }, [currPage, currRowPerPage, query]);

  const getAllReferrals = async () => {
    
    try {
      const response = await axios.get(
        `${url}/api/admin/get_referrals`,{
          params: {
            // currPage: currPage,
            // currRowPerPage: currRowPerPage,
            search: query,
          },
          withCredentials: true,
          headers: {
            'acgt-admin': adminUser
          },
        },
      );

      console.log(response.data);
      
    //   setTotalRowCount(response.data.totalRow);
      setData(response.data.data);
      setDataDuplicate(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  LicenseInfo.setLicenseKey(
	muixlicensekey
  );


  const columns = [
    {
        field: "id",
        headerName: "ID",
        type: "string",
        hide: true,
        disableColumnMenu: true,
        sortable: false,
        width: 50,
    },
    {
        field: "fromUserName",
        headerName: "fromUserName",
        type: "string",
		width: 200,
        disableColumnMenu: true,
        sortable: false,
        editable: false,
    },
    {
        field: "fromUserEmail",
        headerName: "fromUserEmail",
        type: "string",
        // width: 300,
        flex:1,
        disableColumnMenu: true,
        sortable: false,
        editable: false,
    },
    {
        field: "referralDate",
        headerName: "Referral Date",
        type: "string",
		width: 130,
        editable: false,
        disableColumnMenu: true,
        sortable: false,
        valueGetter: (params) => params.value ? params.value.split('T')[0] : ''
    },
    {
        field: "referredUserName",
        headerName: "referredUserName",
        type: "string",
		width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: false,
    },
    {
        field: "referredUserEmail",
        headerName: "referredUserEmail",
        type: "string",
        // width: 300,
        flex:1,
        editable: false,
        disableColumnMenu: true,
        sortable: false,
	},
	{
		field: "referredUserPi",
		headerName: "referredUserPI",
		type: "string",
		width: 170,
		editable: false,
		disableColumnMenu: true,
		sortable: false,
	},
    {
        field: "isRegistered",
        headerName: "Registered?",
        type: "string",
		width: 110,
        editable: false,
        disableColumnMenu: true,
        sortable: false,
        valueGetter: (params) => params.value === null ? '' :params.value === 1 ? "Yes": "No",
        //  renderCell: (params) => (
        //   params.value === "Yes" ? 
        //   <span className="text-green-500 font-bold">{params.value}</span>
        //   :
        //   <span className="">{params.value}</span>
        // )
      },
    {
        field: "isComplete",
        headerName: "Complete?",
        type: "string",
		width: 110,
        editable: false,
        valueGetter: (params) => params.value === null ? '' :params.value === 1 ? "Yes": "No",
         renderCell: (params) => (
          params.value === "Yes" ? 
          <span className="text-green-500 font-bold">{params.value}</span>
          :
          <span className="">{params.value}</span>
        )
      },
   
  ];

  return (
    <>
      <div
        style={{
          paddingTop: 20,
          padding: 30,
          paddingBottom: 10,
          width: "1650px",
        }}
      >
        <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
          <Box>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs style={{width:'100%', display:'flex', justifyContent:'space-between'}}>
                {/* any elements nested inside the role="presentation" preserve their semantics. */}
                <Typography gutterBottom variant="h6" component="div">
                  Referrals
                </Typography>
                {/* <Button variant="outlined" 
                style={{color:'white', backgroundColor:'var(--color-primary-purple)', border:'none', textTransform: 'none', height:30, fontSize:12 }} 
                onClick={() => newDiscount()}>
                  Create Discount
                </Button> */}
              </Grid>
            </Grid>
            <Divider component="div" role="presentation" />

            <Grid
              style={{ paddingTop: 15, paddingBottom: 15, width: "100%" }}
              container
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={9}>
                 <FormControl size="small" style={{ width: "250px" }}>
                    <InputLabel id="demo-simple-select-label">Status</InputLabel>
                    <Select
                      className="admin-order-tables-form-select"
                      label="Company"
                      onChange={handleStatusBoxChange}
                      value={statusBox}
                    >
                      <MenuItem value={-1}>All</MenuItem>
                      <MenuItem value={1}>Complete</MenuItem>
                      <MenuItem value={0}>Not Complete</MenuItem>
                    </Select>
                  </FormControl>
              </Grid>
              <Grid item xs={3}>
                <div className="right-header" >
                  <TextField
                    className="admin-order-tables-form-textfield"
                    placeholder="Search"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={search_value}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {      
                        setQuery(e.target.value);
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => {
                            setSearchValue('')
                            setQuery("")}}
                        >
                          <CancelRoundedIcon />
                        </IconButton>
                      ),
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>

          <Box>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={12}>
                <DataGridPro
                  title="Referrals"
                  hideFooter
                  initialState={{
                    hideFooterPagination: true,
                  }}
                  autoPageSize
                  rowHeight={40}
                  style={{ width: "100%", padding: "10px", height: "1000px" }}
                  columnHeaderHeight={35}
                  rows={data}
                  columns={columns}
                  sx={{
                    '& .MuiDataGrid-columnHeaders': {
                      color: 'var(--color-primary-purple)'
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                      fontWeight: 700,
                    },
                  }}
                />
              </Grid>
              {/* <Grid item xs={12}>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 100]}
                  component="div"
                  count={totalRowCount}
                  rowsPerPage={currRowPerPage}
                  page={currPage}
                  onPageChange={handleChangeCurrPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Grid> */}
            </Grid>
          </Box>

          <Box sx={{ margin: 3 }}>
            <Grid container alignItems="flex-start" spacing={1}>
              <Grid item xs={6}></Grid>
            </Grid>
          </Box>
        </Box>
      </div>
      <br />
    </>
  );
};


export default function Referrals() {
  return <ReferralTable />;
}
